import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import { Box, xcss } from '@atlaskit/primitives';
var containerStyles = xcss({
  display: 'flex',
  position: 'absolute',
  top: 'space.0',
  right: 'space.0',
  lineHeight: "var(--ds-space-200, 16px)",
  gap: 'space.025',
  zIndex: 'card',
  height: 'fit-content',
  width: 'fit-content',
  margin: 'space.075'
});
var resizeOffsetStyles = xcss({
  right: 'space.150'
});
var smallBadgeStyles = xcss({
  margin: 'space.025'
});
var getBadgeSize = function getBadgeSize(width, height) {
  // width is the original width of image, not resized or currently rendered to user. Defaulting to medium for now
  return width && width < 70 || height && height < 70 ? 'small' : 'medium';
};
export var MediaBadges = function MediaBadges(_ref) {
  var children = _ref.children,
    mediaElement = _ref.mediaElement,
    mediaWidth = _ref.mediaWidth,
    mediaHeight = _ref.mediaHeight,
    extendedResizeOffset = _ref.extendedResizeOffset;
  var _useState = useState(getBadgeSize(mediaWidth, mediaHeight)),
    _useState2 = _slicedToArray(_useState, 2),
    badgeSize = _useState2[0],
    setBadgeSize = _useState2[1];
  useEffect(function () {
    var observer = new ResizeObserver(debounce(function (entries) {
      var _entries = _slicedToArray(entries, 1),
        entry = _entries[0];
      var _entry$contentRect = entry.contentRect,
        width = _entry$contentRect.width,
        height = _entry$contentRect.height;
      setBadgeSize(getBadgeSize(width, height));
    }));
    if (mediaElement) {
      observer.observe(mediaElement);
    }
    return function () {
      observer.disconnect();
    };
  }, [mediaElement]);
  if (typeof children === 'function') {
    children = children({
      badgeSize: badgeSize
    });
  }
  if (!mediaElement || React.Children.count(children) === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    as: "div",
    testId: "media-badges",
    "data-media-badges": "true",
    contentEditable: false,
    xcss: [containerStyles, extendedResizeOffset && resizeOffsetStyles, badgeSize === 'small' && smallBadgeStyles]
  }, children);
};